export interface HubspotAction {
  type: 'hubspot';
  method: string;
  data: any;
  extraData?: any;
}

const PORTAL_ID = '143647097';
const HUBSPOT_URL = 'https://api.hsforms.com/submissions/v3/integration/submit/' + PORTAL_ID + '/';

// ==============================|| ACTION MANAGER - HUBSPOT ||============================== //

export async function handleHubspotAction(action: HubspotAction) {
  switch (action.method) {
    case 'support':
      return postSupport(action.data);
    case 'development-issue':
      return postDevelopmentIssue(action.data);
    case 'accompaniment':
      return postAccompaniment(action.data);
    case 'register':
      return postRegister(action.data);
    case 'upgrade-to-pro':
      return postUpgradeToPro(action.data);
    case 'create-member':
      return postCreateMember(action.data);
    case 'confirm-freemium':
      return postConfirmFreemium(action.data);
    case 'confirm-freemium-international':
      return postConfirmFreemium(action.data, 'af1530c0-e53f-4ed2-9b08-73dc119bbf3b');
    default:
      console.info('[ApiManager > handleHubspotAction] - Unknown method');
      break;
  }
}

async function postDevelopmentIssue(data: any) {
  const formGUID = '549b3d0e-75f7-4ac7-a336-6d3ace4dec65';
  const formURL = HUBSPOT_URL + formGUID;

  const fields = [
    {
      objectTypeId: '0-1',
      name: 'firstname',
      value: data.firstname
    },
    {
      objectTypeId: '0-1',
      name: 'lastname',
      value: data.lastname
    },
    {
      objectTypeId: '0-1',
      name: 'phone',
      value: data.phone
    },
    {
      objectTypeId: '0-1',
      name: 'email',
      value: data.email
    },
    {
      objectTypeId: '0-5',
      name: 'subject',
      value: data.subject
    },
    {
      objectTypeId: '0-5',
      name: 'tipo_de_incidencia',
      value: data.type
    },
    {
      objectTypeId: '0-5',
      name: 'content',
      value: data.content
    }
  ].filter((field) => field.value !== undefined && field.value !== null && String(field.value).trim() !== '');

  const body = {
    fields,
    context: {
      pageUri: data.subject || window.location.href,
      pageName: 'Agent HabiHub - Development issue'
    }
  };

  return postRequest(formURL, body)
    .then((response) => {
      console.log(response);
      return response;
    })
    .catch((error) => {
      console.info('[HubspotManager > postDevelopmentIssue > postRequest]: ', error);
      throw error;
    });
}

async function postSupport(data: any) {
  const formGUID = '7d4d6d2b-ff02-4263-9d98-a5ad00053768';
  const formURL = HUBSPOT_URL + formGUID;

  const body = {
    fields: [
      {
        objectTypeId: '0-1',
        name: 'firstname',
        value: data.firstname
      },
      {
        objectTypeId: '0-1',
        name: 'lastname',
        value: data.lastname
      },
      {
        objectTypeId: '0-1',
        name: 'email',
        value: data.email
      },
      {
        objectTypeId: '0-1',
        name: 'phone',
        value: data.phone
      },
      {
        objectTypeId: '0-1',
        name: 'TICKET.subject',
        value: data.subject
      },
      {
        objectTypeId: '0-1',
        name: 'TICKET.tipo_de_incidencia',
        value: data.type
      },
      {
        objectTypeId: '0-1',
        name: 'TICKET.content',
        value: data.content
      }
    ],
    context: {
      pageUri: window.location.href,
      pageName: 'Agent HabiHub - Support'
    }
    // legalConsentOptions: {
    //   consent: {
    //     consentToProcess: true,
    //     text: 'Acepto permitir a HabiHub almacenar y procesar mis datos personales.',
    //     communications: [
    //       {
    //         value: true,
    //         subscriptionTypeId: 135261004,
    //         text: 'Acepto recibir otras comunicaciones de HabiHub.'
    //       }
    //     ]
    //   }
    // }
  };

  return postRequest(formURL, body)
    .then((response) => {
      console.log(response);
      return response;
    })
    .catch((error) => {
      console.info('[HubspotManager > postSupport > postRequest]: ', error);
    });
}

async function postAccompaniment(data: any) {
  const formGUID = '3242d24d-f926-4e01-9f83-51ce2246e21c';
  const formURL = HUBSPOT_URL + formGUID;

  const body = {
    fields: [
      {
        objectTypeId: '0-1',
        name: 'email',
        value: data.email
      },
      {
        objectTypeId: '0-1',
        name: 'phone',
        value: data.phone
      }
    ],
    context: {
      pageUri: window.location.href,
      pageName: 'Agent HabiHub - Accompaniment'
    }
    // legalConsentOptions: {
    //   consent: {
    //     consentToProcess: true,
    //     text: 'Acepto permitir a HabiHub almacenar y procesar mis datos personales.',
    //     communications: [
    //       {
    //         value: true,
    //         subscriptionTypeId: 135261004,
    //         text: 'Acepto recibir otras comunicaciones de HabiHub.'
    //       }
    //     ]
    //   }
    // }
  };

  return postRequest(formURL, body)
    .then((response) => {
      console.log(response);
      return response;
    })
    .catch((error) => {
      console.info('[HubspotManager > postAccompaniment > postRequest]: ', error);
    });
}

async function postRegister(data: any) {
  const formGUID = '753f13d0-a950-45c5-a89c-19eecb2f2929';
  const formURL = HUBSPOT_URL + formGUID;

  const body = {
    fields: [
      {
        objectTypeId: '0-1',
        name: 'firstname',
        value: data.firstname
      },
      {
        objectTypeId: '0-1',
        name: 'lastname',
        value: data.lastname
      },
      {
        objectTypeId: '0-1',
        name: 'email',
        value: data.email
      },
      {
        objectTypeId: '0-1',
        name: 'phone',
        value: data.phone
      },
      {
        objectTypeId: '0-1',
        name: 'company',
        value: data.company
      },
      {
        objectTypeId: '0-1',
        name: 'cliente_pro',
        value: data.pro
      },
      {
        objectTypeId: '0-1',
        name: 'freemium',
        value: data.freemium
      },
      {
        objectTypeId: '0-1',
        name: 'validation_code',
        value: data.codeUrl
      },
      {
        objectTypeId: '0-1',
        name: 'hs_language',
        value: data.language
      },
      {
        objectTypeId: '0-1',
        name: 'fecha_fin_demo',
        value: data.trialEndDate
      },
      {
        objectTypeId: '0-1',
        name: 'code',
        value: data.code
      },
      {
        objectTypeId: '0-1',
        name: 'commercial',
        value: data.commercial
      },
      {
        objectTypeId: '0-1',
        name: 'country',
        value: data.country
      },
      {
        objectTypeId: '0-1',
        name: 'cognito_ID',
        value: data.cognitoId
      }
    ],
    context: {
      pageUri: window.location.href,
      pageName: 'Agent HabiHub - Signup'
    },
    legalConsentOptions: {
      consent: {
        consentToProcess: true,
        text: 'Acepto permitir a HabiHub almacenar y procesar mis datos personales.',
        communications: [
          {
            value: true,
            subscriptionTypeId: 135261004,
            text: 'Acepto recibir otras comunicaciones de HabiHub.'
          }
        ]
      }
    }
  };

  return postRequest(formURL, body)
    .then((response) => {
      console.log(response);
      return response;
    })
    .catch((error) => {
      console.info('[HubspotManager > postRegister > postRequest]: ', error);
    });
}

async function postUpgradeToPro(data: any) {
  const formGUID = '753f13d0-a950-45c5-a89c-19eecb2f2929';
  const formURL = HUBSPOT_URL + formGUID;

  const body = {
    fields: [
      {
        objectTypeId: '0-1',
        name: 'firstname',
        value: data.firstname
      },
      {
        objectTypeId: '0-1',
        name: 'lastname',
        value: data.lastname
      },
      {
        objectTypeId: '0-1',
        name: 'email',
        value: data.email
      },
      {
        objectTypeId: '0-1',
        name: 'company',
        value: data.company
      },
      {
        objectTypeId: '0-1',
        name: 'cliente_pro',
        value: data.pro
      },
      {
        objectTypeId: '0-1',
        name: 'validation_code',
        value: data.codeUrl
      },
      {
        objectTypeId: '0-1',
        name: 'hs_language',
        value: data.language
      },
      {
        objectTypeId: '0-1',
        name: 'fecha_fin_demo',
        value: data.trialEndDate
      },
      {
        objectTypeId: '0-1',
        name: 'code',
        value: data.code
      }
    ],
    context: {
      pageUri: window.location.href,
      pageName: 'Agent HabiHub - Signup'
    },
    legalConsentOptions: {
      consent: {
        consentToProcess: true,
        text: 'Acepto permitir a HabiHub almacenar y procesar mis datos personales.',
        communications: [
          {
            value: true,
            subscriptionTypeId: 135261004,
            text: 'Acepto recibir otras comunicaciones de HabiHub.'
          }
        ]
      }
    }
  };

  return postRequest(formURL, body)
    .then((response) => {
      console.log(response);
      return response;
    })
    .catch((error) => {
      console.info('[HubspotManager > postUpgradeToPro > postRequest]: ', error);
    });
}

async function postCreateMember(data: any) {
  const formGUID = '59af3d71-11b7-4c58-86ff-47b22c715bbc';
  const formURL = HUBSPOT_URL + formGUID;

  const body = {
    fields: [
      {
        objectTypeId: '0-1',
        name: 'email',
        value: data.email
      },
      {
        objectTypeId: '0-1',
        name: 'parent_email',
        value: data.parentEmail
      },
      {
        objectTypeId: '0-1',
        name: 'url_new_member',
        value: data.url
      },
      {
        objectTypeId: '0-1',
        name: 'hs_language',
        value: data.language
      }
    ],
    context: {
      pageUri: window.location.href,
      pageName: 'HabiHub - Create Member'
    },
    legalConsentOptions: {
      consent: {
        consentToProcess: true,
        text: 'Acepto permitir a HabiHub almacenar y procesar mis datos personales.',
        communications: [
          {
            value: true,
            subscriptionTypeId: 135261004,
            text: 'Acepto recibir otras comunicaciones de HabiHub.'
          }
        ]
      }
    }
  };

  return postRequest(formURL, body)
    .then((response) => {
      console.log(response);
      return response;
    })
    .catch((error) => {
      console.info('[HubspotManager > postCreateMember > postRequest]: ', error);
    });
}

async function postConfirmFreemium(data: any, formGUID = '753f13d0-a950-45c5-a89c-19eecb2f2929') {
  const formURL = HUBSPOT_URL + formGUID;

  const body = {
    fields: [
      {
        objectTypeId: '0-1',
        name: 'email',
        value: data.email
      },
      {
        objectTypeId: '0-1',
        name: 'freemium',
        value: true
      }
    ],
    context: {
      pageUri: window.location.href,
      pageName: 'Agent HabiHub - Confirm Freemium'
    }
  };

  return postRequest(formURL, body)
    .then((response) => {
      console.log(response);
      return response;
    })
    .catch((error) => {
      console.info('[HubspotManager > postConfirmFreemium > postRequest]: ', error);
    });
}

// ==============================|| HELPER - POST ||============================== //

export async function postRequest(endpoint: string, data: any) {
  try {
    const response = await fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    });

    if (!response.ok) {
      throw new Error('POST error');
    }

    return await response.json();
  } catch (error) {
    throw new Error('POST error');
  }
}
